"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function LanguagesSkeleton() {
  return (
    <div className="flex flex-col">
      <SkeletonBar className="h-[52px] w-full !rounded-t-md !rounded-b-none" />
      <div className="flex flex-wrap gap-2.5 rounded-b-md border border-border bg-surface-elevated p-5">
        {[70, 55, 65].map((w, i) => (
          <SkeletonBar
            key={i}
            className="h-[33px] !rounded-lg"
            style={{ width: w }}
          />
        ))}
      </div>
    </div>
  );
}
